import { isAxiosError } from "axios";
import { ActionFunction, redirect } from "react-router-dom";
import { backendApi } from "../../api";
import { userQuery } from "../../auth";
import { queryClient } from "../../queryClient";

export const loginAction: ActionFunction = async ({ request }) => {
  const data = Object.fromEntries(await request.formData());
  try {
    const response = await backendApi({
      url: "/auth/login",
      method: "POST",
      data,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    if (response.status !== 200) {
      throw new Error("Invalid username or password.");
    }
    return loggedIn();
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 401) {
      return error.response.data;
    }
    return error;
  }
};

function loggedIn() {
  queryClient.clear();

  //   window.dataLayer?.push({ event: "login" });
  // need to strip base prefix path from next, to prevent /app redirecting to /app/app
  const regex = new RegExp("^" + (import.meta.env.VITE_BASE_PREFIX || ""));
  const next = localStorage.getItem("next")?.replace(regex, "");
  localStorage.removeItem("next");
  return redirect(next || "/");
}

export const logoutAction: ActionFunction = async () => {
  await backendApi({
    url: "/auth/logout",
    method: "POST",
  });
  queryClient.invalidateQueries({ queryKey: userQuery().queryKey });
  return redirect("/auth/login");
};
